import React from 'react';
import FormHelperText from "@mui/material/FormHelperText";
import Bubble from '../../Bubble.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
import InfoTip from '../../InfoTip.js';

/**
 * 
 * @returns 
 */
const WaivedBenefitsBubbles = ({
  userData,
  hasWaivedBenefits,
  setHasWaivedBenefits,
  hasWaivedBenefitsError
}) => {
  const hideSeparateBenefit = userData.waiveFor === 'Self-Dependents' && userData.hasWaived === 'Health-Dental';
  const showExtendedHealth = hideSeparateBenefit !== true && ['Health-Dental', 'Health'].includes(userData.hasWaived);
  const showDental = hideSeparateBenefit !== true && ['Health-Dental', 'Dental'].includes(userData.hasWaived);
  const showExtendedHealthCareDental = userData.hasWaived === 'Health-Dental';
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px',
      // Set the spacing between the items
      width: '85%',
      height: 50
    }
  }, showExtendedHealth ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.labels.changeRequests.extendedHealth),
    isSelected: hasWaivedBenefits === 'Health',
    onClick: () => hasWaivedBenefits !== 'Health' ? setHasWaivedBenefits("Health") : setHasWaivedBenefits(false),
    rightIcon: /*#__PURE__*/React.createElement(InfoTip, {
      active: hasWaivedBenefits === 'Health'
    }),
    onClickRightIcon: () => null
  }) : null, showDental ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.titles.dental),
    isSelected: hasWaivedBenefits === 'Dental',
    onClick: () => hasWaivedBenefits !== 'Dental' ? setHasWaivedBenefits('Dental') : setHasWaivedBenefits(false)
  }) : null, showExtendedHealthCareDental ? /*#__PURE__*/React.createElement(Bubble, {
    label: i18n.t(tokens.labels.changeRequests.extendedHealthCareDental),
    isSelected: hasWaivedBenefits === 'Health-Dental',
    onClick: () => hasWaivedBenefits !== 'Health-Dental' ? setHasWaivedBenefits('Health-Dental') : setHasWaivedBenefits(false)
  }) : null), /*#__PURE__*/React.createElement("div", null, hasWaivedBenefitsError ? /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, hasWaivedBenefitsError) : null));
};
export default WaivedBenefitsBubbles;